import react, { useState } from "react";
import reactDom from "react-dom";
import { useRef, useEffect } from "react";
import WebsiteLogo from "..//Images/Mukstar game website logo.png";
import '../cssfiles/Nav.css';
import { NavLink } from "react-router-dom";

function NavBar(){ 
    let nav = useRef(null);
    let toggleNav = useRef(null);
    let [istrigger,setistrigger] = useState(false);

        function openNav(){
               setistrigger(!istrigger);

        }
     
   return(
    <>
    <header className="Header">
           <div className="MainLogo"><img src={WebsiteLogo} ></img> </div>
     
          <i ref={toggleNav} id="navigatorOpen"onClick={openNav} className={istrigger?"fa-solid fa-x":"fa-solid fa-burger"}></i>
           
           <ul ref={nav} className={istrigger?"Ullist-two":"Ullist"} >
          <NavLink to="/"><li className="Home"><span>Home</span></li></NavLink> 
         <NavLink to="/About">  <li className="Order"><span>About</span></li></NavLink>
         <NavLink to="/Contact">   <li className="Product"><span>Contact</span></li></NavLink>
           </ul>
    </header>
    </>
   );
}
export default NavBar;
